import React from 'react';
import {Redirect} from 'react-router-dom';

import User from 'Services/User';

/**
 * @function ProfileCompleted
 * @param {*|JSX.Element} component
 * @return {*|JSX.Element}
 * @constructor
 */
const ProfileCompleted = ({component}) => {
    if (!window.base.features.allow_profile_change) {
        console.error('You must enable the ds-auth->allow_profile_change config value to use the ProfileCompleted guard.');
    }

    const result = (User.loggedIn && User.data.profile_last_updated) || (User.data.is_admin);

    return result ? component : <Redirect to="/settings/profile" />;
};

export default ProfileCompleted;
